import { Button, Dialog, Grid, Typography } from '@mui/material'
import './HeroSectionNewDesign.css'
import React, { useState } from 'react'
import gridChecks from "../../assests/Pages/CallAnalysis/checks_grid.png"
import callAnalysisHero from './../../assests/Pages/CallAnalysis/call-analysis-hero.png'
import BookACalendlyDialog from '../../Utils/GlobalDialog/BookACalendlyDialog/BookACalendlyDialog'

const HeroSectionNewDesign = () => {
    const [flagOpenBookaMeetingDemo, setFlagOpenBookaMeetingDemo] = useState(false);
    
    return (
        <Grid container className='hero-section-new-design-container' >
            <img src={gridChecks} alt="Grid Background" className="grid-bg-image" />

            <Grid item xs={12} xl={10} className='hero-section-new-main-item'>
                <Grid container alignItems={"center"} justifyContent={"center"} gap={{xs: 3, lg: 4}} className='center-align' sx={{height: "100%"}}>
                    <Grid item xs={12} sm={9.5} lg={10} xl={11}>
                        <Typography variant='h1' className='hero-section-new-heading-style'>
                            Supercharge your insights with AI-Powered Call Analysis
                        </Typography>
                    </Grid>
                    <Grid item  className='hero-section-new-image-style'></Grid>
                    <Grid item xs={11} lg={12}>
                        <Typography variant='p' className='hero-section-new-sub-heading-style'>
                            Unlock the data with Conversation Intelligence
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={11} lg={8}>
                        <Typography variant='p' className='hero-section-new-content-style'>
                            Conversational AI analyzes all your calls, all the time, turning your conversations into easy-to-act-on insights. Discover how to attract and convert more leads, boost frontline team performance, and drive revenue growth.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} >
                        <Button 
                            className='global-primary-button-style' 
                            sx={{width: "175px !important"}}
                            onClick={() => { setFlagOpenBookaMeetingDemo(true) }}
                            aria-label='Get a Demo'
                        >
                            Get a Demo
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

            {
                flagOpenBookaMeetingDemo &&
                <Dialog open={flagOpenBookaMeetingDemo}
                    maxWidth='lg'
                    sx={{ '&.MuiPaper-root': { width: '100%' } }}
                    className="iframe-dialog"
                >
                    <BookACalendlyDialog
                        flagOpenBookaMeetingDemo={flagOpenBookaMeetingDemo}
                        setFlagOpenBookaMeetingDemo={setFlagOpenBookaMeetingDemo}
                    />
                </Dialog>
            }
        </Grid>
    )
}

export default HeroSectionNewDesign
